function convertDateToOnlyDate(date) {
    const newDate=new Date(date);
        // const year=newDate.getFullYear();
        // const month=newDate.getMonth();
        // const day=newDate.getDay();
        // /*month=month<10? "0"+month: month
        // day=day<10? "0"+day:day
        // console.log(year,month,day)*/
        return newDate.toLocaleDateString();
}
function convertDateToTime(date) {
    const newDate=new Date(date);
        return newDate.toLocaleTimeString();
}

export {convertDateToOnlyDate,convertDateToTime}
